import { render, staticRenderFns } from "./DuplicateGroupSkeletonLoader.vue?vue&type=template&id=00880c8b&scoped=true&"
import script from "./DuplicateGroupSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./DuplicateGroupSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateGroupSkeletonLoader.vue?vue&type=style&index=0&id=00880c8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00880c8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VDivider,VSkeletonLoader})
